import { render, staticRenderFns } from "./addSoftWare.vue?vue&type=template&id=7899dfe8&scoped=true"
import script from "./addSoftWare.vue?vue&type=script&lang=js"
export * from "./addSoftWare.vue?vue&type=script&lang=js"
import style0 from "./addSoftWare.vue?vue&type=style&index=0&id=7899dfe8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7899dfe8",
  null
  
)

export default component.exports